import React, { useState } from "react";
import { CheckIcon, ChevronDownIcon } from "lucide-react";
type ExpandableListProps = {
  items: string[];
  initialCount?: number;
};
export function ExpandableList({
  items,
  initialCount = 5
}: ExpandableListProps) {
  const [expanded, setExpanded] = useState(false);
  const visible = expanded ? items : items.slice(0, initialCount);
  const hiddenCount = items.length - initialCount;
  return <div data-id="element-142" data-mp="shw6avh0ktsj">
      <ul className="space-y-2.5" data-id="element-143" data-mp="shmk7iz3b6s4">
        {visible.map(item => <li key={item} className="flex gap-2.5 text-base leading-snug text-ink" data-id="element-144" data-mp="oezx1vdd6a19">
            <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-success" strokeWidth={3} aria-hidden="true" data-id="element-145" data-mp="jfwpa3601ppl" />
            <span data-id="element-146" data-mp="ehlffsfpff7d">{item}</span>
          </li>)}
      </ul>
      {hiddenCount > 0 && <button type="button" onClick={() => setExpanded(v => !v)} aria-expanded={expanded} className="mt-3 inline-flex items-center gap-1.5 rounded-lg py-1 text-sm font-bold text-navy-700 transition-colors duration-150 ease-out hover:text-navy-950 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent" data-id="element-147" data-mp="2dupki12z0eh0">
          {expanded ? "Show less" : `Show ${hiddenCount} more topics`}
          <ChevronDownIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${expanded ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-148" data-mp="20h8vthrmllpb" />
        </button>}
    </div>;
}